import userRoutes from './route';

export default userRoutes;